import React from 'react'
import { Outlet } from 'react-router-dom'

const VavakaPage = () => {
  return (
    <Outlet />
  )
}

export default VavakaPage